import ExportWorkQGroup from "./ExportWorkQGroup";
import CheckboxCell from "../../../common/interactive/CheckboxCell";
import { useEffect, useState } from "react";

export default function ExportWorkQGroupWrapper({classes, item, data, setData, setFilters, checkUncheckHandler, filtersData}) {
    const [selectAll, setSelectAll] = useState(item?.items?.every(item => item.selected))
    function selectAllHandler(value) {
        setSelectAll(value.data.value)
        // value.identifier should have the group name = item.name
        const groupName = value.identifier?.groupName;
        let newData = data.map(group => {
            if (group.name === groupName) {
                return {
                    ...group,
                    items: group.items.map(item => ({
                        ...item,
                        selected: value.data.value
                    }))
                }
            }
            return group;
        })
        setData(newData)
        if (setFilters) {
            setFilters(newData)
        }
    }

    let selectAllValue = item?.items?.every(item => item.selected)
   
    return <>
        <div key={item.name} className={classes.items}>
            <h3 className={classes.title}>
                {item.name}        
                <CheckboxCell checked={selectAllValue} label={selectAllValue ? 'Deselect All' : 'Select All'} direction={'reverse'} setStyle={'box_small'} action={selectAllHandler} identifier={{groupName: item.name}}/>
                        
            </h3>
            {item && item.items && <ExportWorkQGroup items={item.items} actionModifier={checkUncheckHandler} groupName={item.name}/>}                
        </div>
    </>
}